import axios from "axios";
import { API_BASE } from "./backend";

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach token to every request
api.interceptors.request.use((config) => {
  // Procura o token no localStorage OU no sessionStorage
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (Array.isArray(error.response?.data?.detail)) {
      error.response.data.detail = error.response.data.detail.map(item => item.msg).join("; ");
    }
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export function updateOrder(order, changes) {
  if (!Number.isInteger(order?.versao) || order.versao < 1) {
    throw new Error("Recarregue o pedido antes de atualizar.");
  }
  const payload = { ...changes, versao: order.versao };
  delete payload.id_externo;
  return api.put(`/orders/${order.id}`, payload);
}

export default api;
